export default __webpack_public_path__ + "static/media/rightarrow.bde12a6b.svg";